<script setup lang="ts">
/**
 * AgreementCheckbox — 协议同意勾选（登录 / 注册 / 忘记密码共用一套文案）
 * - v-model 双向绑定勾选状态
 * - 文案统一走 i18n：login.agreePrefix / login.terms / login.agreeAnd / login.privacyPolicy
 * - 用户协议与隐私政策链接固定跳 /terms 与 /privacy
 */
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    modelValue: boolean
  }>(),
  { modelValue: false }
)

const emit = defineEmits<{ (e: 'update:modelValue', v: boolean): void }>()

function onChange(e: Event) {
  emit('update:modelValue', (e.target as HTMLInputElement).checked)
}
</script>

<template>
  <label class="yfb-agree">
    <input type="checkbox" :checked="props.modelValue" @change="onChange" />
    <span>
      {{ t('login.agreePrefix') }}
      <a class="yfb-agree__link" href="/terms" target="_blank">{{ t('login.terms') }}</a>
      {{ t('login.agreeAnd') }}
      <a class="yfb-agree__link" href="/privacy" target="_blank">{{ t('login.privacyPolicy') }}</a>
    </span>
  </label>
</template>

<style scoped>
.yfb-agree {
  display: inline-flex;
  align-items: flex-start;
  gap: var(--yfb-sp-2);
  font-size: var(--yfb-fs-sm);
  line-height: 1.5;
  color: var(--yfb-ink-soft);
  cursor: pointer;
  user-select: none;
}

.yfb-agree input[type='checkbox'] {
  flex-shrink: 0;
  margin-top: 2px;
  width: 1rem;
  height: 1rem;
  accent-color: var(--yfb-accent);
  cursor: pointer;
}

.yfb-agree__link {
  color: var(--yfb-accent);
  text-decoration: none;
}

.yfb-agree__link:hover {
  text-decoration: underline;
}
</style>
